<script>
	const analyticsUtilities = require('utilities/analyticsUtilities');
	const AUDIO_PLAY = analyticsUtilities.events.AUDIO_PLAY;
	const AUDIO_PAUSE = analyticsUtilities.events.AUDIO_PAUSE;
	const AUDIO_COMPLETE = analyticsUtilities.events.AUDIO_COMPLETE;

	module.exports = {
		props: {
			url: {
				required: true,
				type: String
			},
			eventData: {
				default: null
			},
			audioPlayEventName: {
				default: AUDIO_PLAY
			},
			audioPauseEventName: {
				default: AUDIO_PAUSE
			},
			audioCompleteEventName: {
				default: AUDIO_COMPLETE
			},
			reverseColor: {
				type: Boolean,
				default: false
			},
			noPause: {
				type: Boolean,
				default: false
			}
		},
		components: {
			'audio-player-icon': require('components/audio-player-icon.vue').default,
			'audio-player': require('components/audio-player.vue').default
		},
		data() {
			return {
				isPlaying: false
			};
		},
		watch: {
			url(val) {
				this.isPlaying = false;
			}
		},
		methods: {
			onAudioClick() {
				const audio = this.$refs.audioPlayer;

				if (audio.paused) {
					this.play();
				} else if (!this.noPause) {
					this.pause();
				}
			},
			play() {
				const audio = this.$refs.audioPlayer;

				if (audio) {
					audio.play();
					this.isPlaying = true;
				}
			},
			pause() {
				const audio = this.$refs.audioPlayer;

				if (audio) {
					audio.pause();
					this.isPlaying = false;
				}
			},
			onEnded() {
				this.isPlaying = false;
			}
		}
	};
</script>
<style lang="scss">
	.audio-player-simple {
		.audio-player {
			display: none;
		}
		.audio-player-icon {
			display: inline-flex;
		}
	}
</style>
<template>
	<span class="audio-player-simple">
		<audio-player-icon
			:reverse="reverseColor"
			:on-audio-click="onAudioClick"
			:is-playing="isPlaying && !noPause">
		</audio-player-icon>
		<audio-player
			ref="audioPlayer"
			:src="url"
			:event-data="eventData"
			:audio-play-event-name="audioPlayEventName"
			:audio-pause-event-name="audioPauseEventName"
			:audio-complete-event-name="audioCompleteEventName"
			@ended="onEnded"></audio-player>
	</span>
</template>
